export const PAYMENT_COMPLETION_KEY = 'web.paymentcompletion.categoryId';
